module.exports = "/_next/static/images/PredictiveAIModels-f0134a5ed0404a99a6bc16bc10ea1414.webp";